export default "__VITE_ASSET__YqrgzVWH__"